// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: experiment.proto

/* eslint-disable */

export const protobufPackage = "usertracking.v3";

export interface Experiment {
  experiment_id: string;
  experiment_name: string;
  variation_id: string;
  variation_name: string;
}

function createBaseExperiment(): Experiment {
  return { experiment_id: "", experiment_name: "", variation_id: "", variation_name: "" };
}

export const Experiment: MessageFns<Experiment> = {
  fromJSON(object: any): Experiment {
    return {
      experiment_id: isSet(object.experiment_id) ? globalThis.String(object.experiment_id) : "",
      experiment_name: isSet(object.experiment_name) ? globalThis.String(object.experiment_name) : "",
      variation_id: isSet(object.variation_id) ? globalThis.String(object.variation_id) : "",
      variation_name: isSet(object.variation_name) ? globalThis.String(object.variation_name) : "",
    };
  },

  toJSON(message: Experiment): unknown {
    const obj: any = {};
    if (message.experiment_id !== "") {
      obj.experiment_id = message.experiment_id;
    }
    if (message.experiment_name !== "") {
      obj.experiment_name = message.experiment_name;
    }
    if (message.variation_id !== "") {
      obj.variation_id = message.variation_id;
    }
    if (message.variation_name !== "") {
      obj.variation_name = message.variation_name;
    }
    return obj;
  },

  create(base?: DeepPartial<Experiment>): Experiment {
    return Experiment.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Experiment>): Experiment {
    const message = createBaseExperiment();
    message.experiment_id = object.experiment_id ?? "";
    message.experiment_name = object.experiment_name ?? "";
    message.variation_id = object.variation_id ?? "";
    message.variation_name = object.variation_name ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
